export const getPermissoes = () => {
  if (JSON.parse(window.localStorage.getItem("usuario")) && JSON.parse(window.localStorage.getItem("usuario")).usuario != undefined) {
    return JSON.parse(window.localStorage.getItem("usuario")).permissoes;
  } else [];
};

export const verificarAcesso = (moduloID, permissao) => {
  if (moduloID === -1) return true;

  let permissoes = getPermissoes();

  if (permissoes && permissoes.length > 0) {
    let acesso = permissoes.find((x) => x.moduloID === moduloID);
    if (!acesso) return false;

    return acesso.permissoes.indexOf(permissao) >= 0;
  } else return false;
};

export const verificarMultiploAcesso = (modulos, permissao) => {
  let permissoes = getPermissoes();
  if (permissoes && permissoes.length > 0) {
    let acesso = permissoes.filter(
      (x) =>
        modulos.indexOf(x.moduloID) >= 0 && x.permissoes.indexOf(permissao) >= 0
    );
    return acesso.length > 0;
  } else return false;
};

export default {
  getPermissoes,
  verificarAcesso,
  verificarMultiploAcesso,
};
